import type { IPlaybackScheduleRoot } from '@lucimark/shared/models/player-registration-payload'

/**
 * Asset URNs referenced by a playback schedule root (direct playlist frames + embedded
 * playlist frames). Used both to know what to download (`PlaybackScheduleLoader`) and to
 * protect currently scheduled assets from age-based cache eviction, so a player that has
 * been offline longer than the eviction window can still play from cache after a reboot.
 */
export function collectScheduleRootAssetUrns(root: IPlaybackScheduleRoot | null | undefined): Set<string> {
  const urns = new Set<string>()
  if (root == null) {
    return urns
  }
  for (const playlist of root.playlists ?? []) {
    for (const frame of playlist.frames ?? []) {
      for (const { asset } of Object.values(frame.facets ?? {})) {
        urns.add(asset)
      }
    }
  }
  for (const frames of Object.values(root.embeddedPlaylistFrames ?? {})) {
    for (const frame of frames ?? []) {
      for (const { asset } of Object.values(frame.facets ?? {})) {
        urns.add(asset)
      }
    }
  }
  return urns
}
